import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findSpecialNoteList,
	changeSpecialNotActivePage
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['labelReducer', 'orderId']),
	data: state.getIn(['specialNoteListReducer', 'specialNoteList']),
	activePage: state.getIn(['specialNoteListReducer', 'activePage']),
	itemPerPage: state.getIn(['specialNoteListReducer', 'itemPerPage']),
	totalPage: state.getIn(['specialNoteListReducer', 'totalPage']),
	fields: {
		serial_no: '編號',
		customer_gear_name: '衣褲',
		color_display: '顏色',
		sizing_display: '尺寸',
		special_note: '備註'
	},
	keys: ['order_label_id'],
	disableAdd: true,
	disableEdit: true
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: (pagingData) => {
		if (ownProps.orderId) {
			dispatch(findSpecialNoteList({ orderId: ownProps.orderId }, pagingData));
		}
	},
	changeActivepage: (pagingData) => {
		dispatch(changeSpecialNotActivePage(pagingData));
		dispatch(findSpecialNoteList({ orderId: ownProps.orderId }, pagingData));
	},
})

const SpecialNoteListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default SpecialNoteListContainer;


// WEBPACK FOOTER //
// ./src/containers/SpecialNoteListContainer.jsx